// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
// import translationHI from './locales/hi/translation.json';
import translationRO from './locales/ro/translation.json';

const resources = {
  en: { translation: translationEN },
  ro: { translation: translationRO },
  // hi: { translation: translationHI },
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Bind react-i18next
  .init({
    resources,
    fallbackLng: 'ro', // Romanian is default
    supportedLngs: ['en', 'ro'],
    detection: {
      order: ['path', 'navigator'],
      lookupFromPathIndex: 0,
      // No cookie or localStorage, only path and browser
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
